import {connect} from "react-redux";
import ToolkitInspectionForm from "./toolkitInspectionForm";
import {bindActionCreators} from "redux"
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import {fetchMaterials, saveMaterialInspection} from 'services/redux/ToolkitInspection/action'

const mapStateToProps = (state) => ({
    fetchMaterialList: state.toolkitInspection.fetchMaterialList,
});

const mapDispatchToProps = (dispatch) => 
    bindActionCreators({
        fetchMaterials,
        saveMaterialInspection,
        documentUploadUrlPublic,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ToolkitInspectionForm);